export * from 'react-native';



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/node_modules/react-native-vector-icons/lib/react-native.js